module.exports = __webpack_public_path__ + "img/wireframes_02.0c987e65.png";